import { useState } from "react";
import { IAP } from "@pms/shared";

export default function Settings() {
  const [key, setKey] = useState("");
  const [aiOn, setAiOn] = useState(false);
  const [status, setStatus] = useState("No key stored (session only in scaffold)");

  return (
    <>
      <div className="card">
        <h2>Subscription</h2>
        <p>
          User <strong>${IAP.userPriceUsdYear}/year</strong> · Admin{" "}
          <strong>${IAP.adminPriceUsdYear}/year</strong> (IAP). Web Stripe later.
        </p>
        <div className="row">
          <button type="button" className="btn" disabled>
            User plan (Phase 5)
          </button>
          <button type="button" className="btn primary" disabled>
            Admin plan (Phase 5)
          </button>
        </div>
        <p style={{ marginTop: 8 }}>Product IDs: {IAP.userYearly} · {IAP.adminYearly}</p>
      </div>

      <div className="card">
        <h2>xAI / Grok (BYOK)</h2>
        <p>Your key = your bill. Never stored on our servers. Product works with AI off.</p>
        <label style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
          <input type="checkbox" checked={aiOn} onChange={(e) => setAiOn(e.target.checked)} />
          Enable AI suggestions
        </label>
        <input
          type="password"
          placeholder="xAI API key"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          disabled={!aiOn}
          style={{
            width: "100%",
            maxWidth: 480,
            padding: "0.55rem 0.7rem",
            borderRadius: 8,
            border: "1px solid var(--border)",
            background: "var(--panel-2)",
            color: "var(--text)",
          }}
        />
        <div className="row" style={{ marginTop: 8 }}>
          <button
            type="button"
            className="btn"
            disabled={!aiOn || !key}
            onClick={() => setStatus("Scaffold: no network call yet. Wire in Phase 4.")}
          >
            Test connection
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => {
              setKey("");
              setStatus("Key cleared from UI");
            }}
          >
            Remove key
          </button>
        </div>
        <p style={{ marginTop: 8 }}>{status}</p>
      </div>
    </>
  );
}
